<template>
    <DropdownMenuSub>
        <DropdownMenuSubTrigger> API </DropdownMenuSubTrigger>
        <DropdownMenuPortal>
            <DropdownMenuSubContent>
                <DropdownMenuItem v-for="link in apiLinks" :key="link.to" as-child>
                    <NuxtLink :to="localePath(link.to)">
                        {{ link.title }}
                    </NuxtLink>
                </DropdownMenuItem>
            </DropdownMenuSubContent>
        </DropdownMenuPortal>
    </DropdownMenuSub>
</template>

<script setup lang="ts">
const localePath = useLocalePath();

const apiLinks = [
    { title: "Inventory API", to: "/docs/api" },
    { title: "Inventory AI Agent Service", to: "/docs/ai-agents" },
];
</script>
